"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
// TODO: @sachinr4 to revisit as injected engine configuration
exports.config = { CASE_SENSITIVE: false };
//# sourceMappingURL=config.js.map